export const humanReadable = (
  value: number,
  decimalPlaces: number = 2,
): string => {
  const num = Math.abs(value);
  const sign = value < 0 ? '-' : '';

  const formatted = (n: number): string =>
    parseFloat(n.toFixed(decimalPlaces)).toString(); // Removes unnecessary trailing zeros

  switch (true) {
    case num >= 1_000_000_000_000:
      return `${sign}${formatted(num / 1_000_000_000_000)}T`;
    case num >= 1_000_000_000:
      return `${sign}${formatted(num / 1_000_000_000)}B`;
    case num >= 1_000_000:
      return `${sign}${formatted(num / 1_000_000)}M`;
    case num >= 1_000:
      return `${sign}${formatted(num / 1_000)}K`;
    default:
      return `${sign}${formatted(num)}`;
  }
};
